
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { OptionItem } from '../../../models/option-translation.model';
import { TranslateModule } from '@ngx-translate/core';
import { LOVResponseModel } from '../../../models/lov-response.model';
import { LookupService } from '../../../../core/services/lookup.service';
import { LovSelectionService } from '../../../../core/services/lov-selection.service';
import { Utils } from '../../../../Utils/utils';
import { LookupKey } from '../../../constants/lookup-keys';
import { SharedService } from '../../../services/shared.service';
import { ReactiveFormsModule, Validators } from '@angular/forms';

@Component({
  selector: 'app-boolean',
  imports: [TranslateModule, ReactiveFormsModule],
  templateUrl: './boolean.component.html',
  styleUrl: './boolean.component.css'
})
export class BooleanComponent implements OnChanges {
  @Input() label = '';
  @Input() options: any = [];
  @Input() control!: any;
  @Input() validationMessages: { [key: string]: string } = {};
  @Input() disabledOptions: any = [];
  @Input() disabled: boolean = false;
  @Output() onSelectionChange = new EventEmitter();

  @Input() lovType: string = "";
  @Input() labelKey: string = "label";
  @Input() valueKey: string = "value";
  @Input() descriptionKey: string = "description";
  @Input() stacked: boolean = false;
  @Input() labelBold: boolean = false;
  @Input() optionWrapperClass: string = "";
  @Input() translateOptions: boolean = false;

  // if value is load based on parent
  @Input() formSelectedOptions: any = "";
  @Input() parentKey: any = "Value";
  @Input() parentLovType: any = "";
  @Input() loading: boolean = false;

  groupName: any = "";
  get isRequired(): boolean {
    const hasRequired = this.control?.hasValidator?.(Validators.required);
    const hasRequiredTrue = this.control?.hasValidator?.(Validators.requiredTrue);
    return Boolean(hasRequired || hasRequiredTrue);
  }

  // This method is used to initialize the class instance using lookup service, lov service, and shared service
  constructor(
    private lookupService: LookupService,
    private lovService: LovSelectionService,
    private sharedService: SharedService
  ) {
   
  }
  // This method is used to error keys
  get errorKeys(): string[] {
    return this.control?.errors ? Object.keys(this.control.errors) : [];
  }
  // This method is used to check if disabled using val
  isDisabled = (val: string) => this.disabledOptions?.includes(val);

  // This method is used to handle the on changes lifecycle hook using changes
  ngOnChanges(changes: SimpleChanges): void {
    this.groupName = this.label.toLocaleLowerCase().replace(' ', '-');
     if (this.lovType) {
      this.loadOptions('');
    }
  }
  // This method is used to handle value change event using value
  onValueChange(value: any) {
    this.control.setValue(value);
    this.control.markAsTouched();
    this.onSelectionChange.emit(value)
  }

  // This method is used to load options using parent value
  loadOptions(parentValue: string) {
    this.loading = true;
    this.lookupService
      .post<LOVResponseModel>(LookupKey.LOOKUP_URL, {
        ProcessName: "DC Get List Of Values WF",
        Type: this.lovType,
        ParentValue: parentValue || ''
      })
      .subscribe({
        next: (result: LOVResponseModel) => {
          this.loading = false;
          if (result.SiebelMessage?.['List Of Values'] && !result["Error Message"]) {
            this.options = Utils.checkIsArray(result.SiebelMessage['List Of Values']);
            //Exclude the Bank Guarantee if member does not have balance
            if (this.lovType === LookupKey.PAYMENT_METHOD && !this.hasPositiveBankGuaranteeBalance()) {
              this.options = this.options.filter((option: any) => !this.isBankGuaranteeOption(option));
            }

            if (
              this.control?.value &&
              !this.options.some((option: any) => option?.['Value'] === this.control.value)
            ) {
              this.control.setValue(null);
            }
            //end

            let selectedOption: any = "";
            if (this.control.value && this.options) {
              selectedOption = this.options.find((lov: any) => lov['Value'].toLowerCase() == this.control.value.toLowerCase())
            }
            this.selectionChange(selectedOption, this.options);
          } else {
            this.options = [];
          }
        },
        // This method is used to handle the error callback using e
        error: (e) => {
          this.loading = false;
        }
      });
  }

  private hasPositiveBankGuaranteeBalance(): boolean {
    const primaryAccount = this.sharedService.getPrimaryAccount();
    const rawBalance = primaryAccount?.["DC Bank Guarantee Bal"];
    const parsedBalance = Number(String(rawBalance ?? '').replace(/,/g, '').trim());
    return Number.isFinite(parsedBalance) && parsedBalance > 0;
  }

  private isBankGuaranteeOption(option: any): boolean {
    const normalize = (value: any) => String(value ?? '').trim().toLowerCase();
    const name = normalize(option?.Name);
    const value = normalize(option?.Value);
    return name === 'bank guarantee' || value === 'bank guarantee';
  }
  // This method is used to selection change using e and list
  selectionChange(e: any, list: any = "") {
    let object = { lovType: this.lovType, selectedLov: e, list: list };
    this.onSelectionChange.emit(object);
  }
}
